<template>
    <div class="tsa-createProcess" :class="type">
        <div class="title" v-show="titleShow">
            <p>创作过程认证</p>
        </div>
        <div class="step-item" :class="[ item.isFold ? 'fold' : '', item.fileNum === 0 ? 'disabled' : '' ]" v-for="(item, index) in data" :key="index">
            <div class="top" @click.stop="foldFun(item)">
                <div class="icon">
                    <span class="el-icon-arrow-up"></span>
                </div>
                <h4>阶段{{index+1}}：{{ item.name }}（{{ item.fileNum }}）</h4>
            </div>
            <div class="bottom" v-if="item.children.length > 0">
                <TsaTable
                    :data="item.children"
                    stripe
                    style="width: 100%"
                    ref="TsaTable"
                    customRowKey="id"
                >
                    <!-- <el-table-column
                        v-if="fromPage === 'copyrightThird' || fromPage === 'copyrightAuthDetail' || fromPage === 'copyrightAuthSuccess' || fromPage === 'certificateVerify'"
                        prop="index"
                        label="序号"
                        min-width="60"
                        align="center"
                    >
                        <template slot-scope="scope">{{ scope.$index + 1 > 9 ? scope.$index + 1 : '0' + (scope.$index + 1) }}</template>
                    </el-table-column> -->
                    <el-table-column
                        prop="name"
                        label="名称"
                        align="left"
                        :min-width="$route.path=='/copyright/copyrightThird'? 140 : 110"
                    >
                        <template slot-scope="scope">
                            <div class="cell-container" @click.stop="gotoDetail(scope.row)">
                                {{ scope.row.name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                       v-if="fromPage === 'copyrightThird' || fromPage === 'copyrightAuthDetail' || fromPage === 'copyrightAuthSuccess' || fromPage === 'certificateVerify'"
                        min-width="80"
                        prop="storeType"
                        label="认证方式"
                        align="center"
                    >
                        <template slot-scope="scope">{{ scope.row.storeType === 1 ? '存证认证' : scope.row.storeType === 0 ? '保密认证' : '' }}</template>
                    </el-table-column>
                    <!-- <el-table-column
                        v-if="fromPage === 'certifiedWork' || fromPage === 'copyrightThird' || fromPage === 'copyrightAuthDetail' || fromPage === 'copyrightAuthSuccess' || fromPage === 'certificateVerify'"
                        min-width="120"
                        prop="operatedAt"
                        label="认证时间"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <el-tooltip
                                effect="dark"
                                :content="scope.row.operatedAt | timeFormat('YYYY-MM-DD HH:mm:ss')"
                                placement="bottom"
                                popper-class="myShadowTooltip"
                            >
                                <div class="cell-container">
                                    {{ scope.row.operatedAt | timeFormat('YYYY-MM-DD HH:mm:ss')}}
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column> -->
                    <el-table-column
                        :width="$route.path=='/copyright/copyrightThird' ? 80 : 110"
                        label="操作"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div class="table-action-container">
                                <template v-if="fromPage === 'certifiedWork' || fromPage === 'copyrightAuthDetail' || fromPage === 'copyrightAuthSuccess' || fromPage === 'myDraft'">
                                    <p class="table-actiob-btn" @click.stop="gotoDetail(scope.row)">详情</p>
                                    <!-- <p class="table-actiob-btn" @click.stop="share(scope.row)">{{ scope.row.sharingStatus === 1 ? '已分享' : '分享' }}</p> -->
                                    <TsaTableActionPopover text="下载" v-if="downloadShow(scope.row)">
                                        <div class="item" :class="scope.row.sourceFileUploadType === 1 ? '' : 'disabled'" @click.stop="downloadEvidence(scope.row)">下载证据</div>
                                        <div class="item" @click.stop="downloadCertificate(scope.row)">下载证书</div>
                                        <div class="item" @click.stop="downloadTsa(scope.row)">下载tsa</div>
                                    </TsaTableActionPopover>
                                </template>
                                <template v-if="fromPage === 'copyrightThird'">
                                    <p class="table-actiob-btn" @click.stop="gotoDetail(scope.row)">详情</p>
                                </template>
                                <template v-if="fromPage === 'certificateVerify'">
                                    <p class="table-actiob-btn">详情</p>
                                </template>
                            </div>
                        </template>
                    </el-table-column>
                </TsaTable>
                <div class="loadMore-container" :class="item.moreExtend ? 'moreExtend' : ''" v-show="item.fileNum > 5">
                    <div class="loadMore" @click.stop="loadAll(item)">
                        <p>{{ item.moreExtend === true ? '收起' : '更多'}}</p>
                        <span class="el-icon-arrow-down"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { downloadFile } from '@/common/copyright/fileUtil'
import actionsMinix from '@/mixins/actions'
import { allEvidenceDownNewApi } from '@/api/pan/index'
import { analysisSourceType } from '@/components/copyright/basics/iframeDialog/config/index'

export default {
    props: {
        type: {
            type: String,
            default: 'detail' // table
        },
        titleShow: {
            type: Boolean,
            default: true
        },
        fromPage: {
            type: String,
            default: '' // certifiedWork=我的认证作品列表   copyrightThird=作品版权认证第三步骤   copyrightAuthDetail=作品详情  copyrightAuthSuccess=作品认证成功页面  myDraft=作品草稿箱 certificateVerify=证书验证扫码
        },
        data: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    computed: {
        ...mapState({
            parentIframe: (state) => state.app.parentIframe,
        }),
    },
    mixins: [ actionsMinix ],
    methods: {
         ...mapActions({
            getBalanceInfo: 'balance/getBalanceInfo',
        }),
        // 是否显示下载
        downloadShow(row) {
            // 境外取证审核不通过 按理说不会进入到这里
            if (row.approveStatus === 4) {
                return false
            }
            // 如果是邮件认证并且没有原件（脱敏）的情况下不显示详情
            if ((this.analysisSourceType(row) === 700025) && row.sourceFileUploadType === 0) {
                return false
            }
            return true
        },
        // 获取 解析 sourceType
        analysisSourceType (row) {
            let id = row.dataId || row.id
            return analysisSourceType(id)
        },
        // 下载证据
        downloadEvidence(row) {
            // return
            if (row.sourceFileUploadType === 1) {
                let {parentIframe}=this;
                if(parentIframe === 'ANDROID-RIGHTS' || parentIframe === 'IOS-RIGHTS' || parentIframe === 'HARMONYOSNEXT-RIGHTS' || parentIframe ==='WEIXIN'){
                    this.$TsaAlertV2.show({
                        title: '下载证据',
                        message: '请登录电脑端证据管理中心“https://file.tsa.cn/”在[全部证据]中操作。',
                        type: 'warn',
                        confirmButtonText: '我知道了',
                        onConfirm: () => {
                            this.$TsaAlertV2.hide()
                        },
                    })
                    return
                }
                this.$TsaLoadingV2.show()
                allEvidenceDownNewApi({
                    esIds: [row.dataId],
                    type: 1
                }).then((res) => {
                    this.$TsaLoadingV2.hide()
                    if (res && res[0] && res[0].applyFileUrl) {
                        this.$emit('on-actions', {
                            type: 'downloadEvidence',
                        })
                        downloadFile(res[0].applyFileUrl)
                        // this.$TsaToastV2.show({
                        //     message: '下载成功',
                        //     type: 'success'
                        // })
                    } else {
                        this.$TsaToastV2.show({
                            message: '获取下载链接失败',
                            type: 'error'
                        })
                    }
                    
                }).catch((error) => {
                    let { status, data } = error
                    if (status === 400) {
                        if (data.code === 444) {
                            this.gotoDetailCommon({ row, specialStatus: 'storeExpired'}, 'createProcess')
                        } else {
                            this.$TsaToastV2.show({
                                message: data.message,
                                type: 'error'
                            })
                        }
                    }
                })
                
            }
        },
        // 下载pdf
        downloadCertificate(row) {
            let {parentIframe}=this;
            if(parentIframe === 'ANDROID-RIGHTS' || parentIframe === 'IOS-RIGHTS' || parentIframe === 'HARMONYOSNEXT-RIGHTS' || parentIframe ==='WEIXIN'){
                this.$TsaAlertV2.show({
                    title: '下载证书',
                    message: '请登录电脑端证据管理中心“https://file.tsa.cn/”在[全部证据]中操作。',
                    type: 'warn',
                    confirmButtonText: '我知道了',
                    onConfirm: () => {
                        this.$TsaAlertV2.hide()
                    },
                })
                return
            }
            this.$TsaLoadingV2.show()
            allEvidenceDownNewApi({
                esIds: [row.dataId],
                type: 0
            }).then((res) => {
                this.$TsaLoadingV2.hide()
                if (res && res[0] && res[0].pdfUrl) {
                    this.$emit('on-actions', {
                        type: 'downloadCertificate',
                    })
                    downloadFile(res[0].pdfUrl)
                    // this.$TsaToastV2.show({
                    //     message: '下载成功',
                    //     type: 'success'
                    // })
                } else {
                    this.$TsaToastV2.show({
                        message: '下载失败',
                        type: 'error'
                    })
                }
            }).catch((error) => {
                let { status, data } = error
                this.$TsaLoadingV2.hide()
                if (status === 400) {
                    this.$TsaToastV2.show({
                        message: data.message,
                        type: 'error'
                    })
                }
            })
        },
        // 下载tsa
        downloadTsa(row) {
            let {parentIframe}=this;
            if(parentIframe === 'ANDROID-RIGHTS' || parentIframe === 'IOS-RIGHTS' || parentIframe === 'HARMONYOSNEXT-RIGHTS' || parentIframe ==='WEIXIN'){
                this.$TsaAlertV2.show({
                    title: '下载证书',
                    message: '请登录电脑端证据管理中心“https://file.tsa.cn/”在[全部证据]中操作。',
                    type: 'warn',
                    confirmButtonText: '我知道了',
                    onConfirm: () => {
                        this.$TsaAlertV2.hide()
                    },
                })
                return
            }
            this.$TsaLoadingV2.show()
            allEvidenceDownNewApi({
                esIds: [row.dataId],
                type: 3
            }).then((res) => {
                this.$TsaLoadingV2.hide()
                if (res && res[0] && res[0].tsaUrl) {
                    this.$emit('on-actions', {
                        type: 'downloadTsa',
                    })
                    downloadFile(res[0].tsaUrl)
                    // this.$TsaToastV2.show({
                    //     message: '下载成功',
                    //     type: 'success'
                    // })
                } else {
                    this.$TsaToastV2.show({
                        message: '下载失败',
                        type: 'error'
                    })
                }
                
            }).catch((error) => {
                this.$TsaLoadingV2.hide()
                let { status, data } = error
                if (status === 400) {
                    this.$TsaToastV2.show({
                        message: data.message,
                        type: 'error'
                    })
                }
            })
            
        },
        loadAll (item) {
            if (item.moreExtend) {
                item.moreExtend = false
                item.children = item.children.slice(0, 5)
            } else {
                this.$set(item, 'moreExtend', true)
                this.$emit('on-loadAll', item)
            }
            
        },
        // 折叠函数
        foldFun (item) {
            if (item.fileNum > 0) {
                item.isFold = !item.isFold
            }
        },
        share (row) {
            this.$emit('on-actions', {
                type: 'share',
            })
            this.gotoShareCommon({ row })
        },
        async gotoDetail (row) {
            this.gotoDetailCommon({ row }, 'createProcess')
        }
    },
}
</script>

<style lang="scss" scoped>
    @import './css/mobile.scss';
</style>
